export default __webpack_public_path__ + "static/media/github-circle.747f240d.svg";